import { createContext, useContext } from "react";

/**
 * Per-request CSP nonce. Generated server-side in entry.server.tsx and read by
 * root.tsx so <Scripts>/<ScrollRestoration> can carry it, allowing a strict
 * Content-Security-Policy (script-src 'self' 'nonce-…') with no 'unsafe-inline'.
 *
 * On the client the provider is absent, so this defaults to "". React treats
 * the `nonce` prop specially and strips it from the DOM, so there is no
 * hydration mismatch.
 */
export const NonceContext = createContext<string>("");

export const useNonce = () => useContext(NonceContext);
